/*
  Product-only bundle (PDP)
  - Related products / "You might also like" slider
  - Product image/gallery sliders
  - Size guide modal
  - Image zoom

  Loaded only on product pages to keep global JS lean.
*/

(function ($) {
  'use strict';  function jsProdDetails(){
    if($(window).width() < 576){
    	$('.js_sticy_imgmb').addClass('js_prod_detail')
    }
    $(window).resize(function() {
      if($(window).width() < 576){
        $('.js_sticy_imgmb').addClass('js_prod_detail')
      }
    });
    
    $('.js_prod_detail').slick({
      dots: true,
      arrows:true,
      infinite: false,
      speed: 300,
      autoplay:false,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow:'<button type="button" class="next-slide"><svg version="1.1" baseProfile="basic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1000px" height="500px" viewBox="0 0 1000 500" xml:space="preserve"> <g id="Forma_1_1_"> <g id="Forma_1"> <path fill-rule="evenodd" clip-rule="evenodd" d="M834.107,232.981L618.365,17.218c-9.3-9.624-24.779-9.624-34.405,0 c-9.299,9.303-9.299,24.778,0,34.059l174.447,174.441H182.759c-13.42,0.021-24.086,10.686-24.086,24.108 c0,13.417,10.666,24.436,24.086,24.436h575.648L583.96,448.375c-9.299,9.63-9.299,25.12,0,34.401 c9.626,9.632,25.128,9.632,34.405,0l215.742-215.742C843.733,257.739,843.733,242.263,834.107,232.981z"/> </g> </g> <g id="Forma_1_copy_1_"> </g> </svg></button>',
      prevArrow:'<button type="button" class="prev-slide"><svg version="1.1" baseProfile="basic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1000px" height="500px" viewBox="0 0 1000 500" xml:space="preserve"> <g id="Forma_1_1_"> </g> <g id="Forma_1_copy_1_"> <g id="Forma_1_copy"> <path fill-rule="evenodd" clip-rule="evenodd" d="M811.881,225.728H245.96L417.457,51.275c9.143-9.269,9.143-24.751,0-34.055 c-9.463-9.627-24.679-9.627-33.821,0l-212.1,215.762c-9.462,9.282-9.462,24.765,0,34.054l212.1,215.742 c9.12,9.627,24.358,9.627,33.821,0c9.143-9.276,9.143-24.772,0-34.4L245.96,274.265h565.921c13.192,0,23.68-11.014,23.68-24.434 C835.561,236.411,825.073,225.749,811.881,225.728z"/> </g> </g> </svg></button>',
    });

  }
  
  function jsProdRelate(){
    $('.js_product_related').each(function(){
      var $slider = $(this);
      var $wrap   = $slider.closest('.es-related-reco, .es-related-fullwidth, .related-product, .product-related');
      var isEsReco = $slider.hasClass('es-related-slider') || $slider.closest('.es-related-reco, .es-related-fullwidth').length;//*esrel*/

      // If this slider was already initialized elsewhere, reset it so changes actually apply.
      if ($slider.hasClass('slick-initialized')) {
        try { $slider.slick('unslick'); } catch (e) {}
      }
      if (isEsReco) {
        var $prev = $wrap.find('.es-related-prev');
        var $next = $wrap.find('.es-related-next');
        var $progressBar = $wrap.find('.es-related-progress-bar');

        // Clean up previous handlers (in case of section re-render / theme editor)
        $prev.off('.esrel');
        $next.off('.esrel');
        $slider.off('.esrel');

        // Helper: update arrows + progress + fade masks
        var updateArrows = function(event, slick){
          slick = slick || ($slider.hasClass('slick-initialized') ? $slider.slick('getSlick') : null);
          if (!slick || !$prev.length || !$next.length) return;

          var show = (slick.options && slick.options.slidesToShow) ? slick.options.slidesToShow : 1;
          var maxIndex = Math.max(0, slick.slideCount - show);

          var atStart = slick.currentSlide <= 0;
          var atEnd = slick.currentSlide >= maxIndex;

          $prev.prop('disabled', atStart)
               .toggleClass('slick-disabled', atStart)
               .attr('aria-disabled', atStart);

          $next.prop('disabled', atEnd)
               .toggleClass('slick-disabled', atEnd)
               .attr('aria-disabled', atEnd);

          // Fade masks (premium)
          $wrap.toggleClass('es-related-at-start', atStart);
          $wrap.toggleClass('es-related-at-end', atEnd);

          // Progress bar
          if ($progressBar.length) {
            var ratio = maxIndex === 0 ? 0 : (slick.currentSlide / maxIndex);
            var pct = Math.max(0, Math.min(100, ratio * 100));
            $progressBar.css('width', pct.toFixed(1) + '%');
          }
        };

        // Compute how many cards equal ~85% of the visible width, then snap-align to card index.
        var calcPageDelta = function(slick){
          if (!slick || !slick.$list || !slick.$slides || !slick.$slides.length) return 1;
          var listW = $(slick.$list).width();
          var $first = $(slick.$slides[0]);
          var slideW = $first.outerWidth(true) || (listW / ((slick.options && slick.options.slidesToShow) ? slick.options.slidesToShow : 1));
          var targetPx = listW * 0.85;
          var delta = Math.max(1, Math.floor(targetPx / slideW));
          return delta;
        };

        var pageGo = function(dir){
          if (!$slider.hasClass('slick-initialized')) return;
          var slick = $slider.slick('getSlick');
          var show = (slick.options && slick.options.slidesToShow) ? slick.options.slidesToShow : 1;
          var maxIndex = Math.max(0, slick.slideCount - show);
          var delta = calcPageDelta(slick);

          var nextIndex = (dir > 0) ? (slick.currentSlide + delta) : (slick.currentSlide - delta);
          if (nextIndex < 0) nextIndex = 0;
          if (nextIndex > maxIndex) nextIndex = maxIndex;

          $slider.slick('slickGoTo', nextIndex);
        };

        // Bind before init so `init` fires into our handler.
        $slider.on('init.esrel reInit.esrel afterChange.esrel breakpoint.esrel setPosition.esrel', updateArrows);

        // Slick init (dense + draggable, but our arrows do page-style scroll)
        $slider.slick({
          dots: false,
          arrows: false, // we use our own ES-style buttons
          infinite: false,
          speed: 420,
          cssEase: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
          autoplay: false,
          slidesToShow: 8,
          slidesToScroll: 1,
          swipeToSlide: true,
          draggable: true,
          touchThreshold: 10,
          responsive: [
            { breakpoint: 1600, settings: { slidesToShow: 8, slidesToScroll: 1 } },
            { breakpoint: 1440, settings: { slidesToShow: 7, slidesToScroll: 1 } },
            { breakpoint: 1280, settings: { slidesToShow: 6, slidesToScroll: 1 } },
            { breakpoint: 1024, settings: { slidesToShow: 4, slidesToScroll: 1 } },
            { breakpoint: 768,  settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 480,  settings: { slidesToShow: 2, slidesToScroll: 1 } }
          ]
        });

        // Arrow clicks -> page scroll (~85% of a screen), snap-aligned
        if ($prev.length) {
          $prev.on('click.esrel', function(e){
            e.preventDefault();
            pageGo(-1);
          });
        }
        if ($next.length) {
          $next.on('click.esrel', function(e){
            e.preventDefault();
            pageGo(1);
          });
        }

        // Premium grab cursor state during drag
        $slider.on('mousedown.esrel touchstart.esrel', function(){
          $slider.addClass('es-is-dragging');
        });
        $(document).on('mouseup.esrel touchend.esrel touchcancel.esrel', function(){
          $slider.removeClass('es-is-dragging');
        });

        // Mouse wheel / trackpad: vertical wheel -> horizontal paging (desktop only)
        var lastWheel = 0;
        $slider.on('wheel.esrel', function(e){
          if ($(window).width() < 992) return; // don't interfere with mobile scroll
          var oe = e.originalEvent || e;
          if (!oe) return;

          // Only intercept when the intent is a vertical scroll gesture
          var dy = oe.deltaY || 0;
          var dx = oe.deltaX || 0;
          if (Math.abs(dy) < Math.abs(dx)) return;

          var now = Date.now();
          if (now - lastWheel < 320) return; // throttle
          lastWheel = now;

          e.preventDefault();
          if (dy > 0) pageGo(1); else pageGo(-1);
        });

        // Initial state
        try { updateArrows(null, $slider.slick('getSlick')); } catch(e) {}
        return;
      }

      // Legacy (non-recommendation) sliders keep the old behaviour
      $slider.slick({
        dots: true,
        arrows: false,
        infinite: false,
        speed: 300,
        autoplay: false,
        slidesToShow: 4,
        slidesToScroll: 2,
        nextArrow:'<button type="button" class="next-slide"><svg version="1.1" baseProfile="basic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1000px" height="500px" viewBox="0 0 1000 500" xml:space="preserve"> <g id="Forma_1_1_"> <g id="Forma_1"> <path fill-rule="evenodd" clip-rule="evenodd" d="M834.107,232.981L618.365,17.218c-9.3-9.624-24.779-9.624-34.405,0 c-9.299,9.303-9.299,24.778,0,34.059l174.447,174.441H182.759c-13.42,0.021-24.086,10.686-24.086,24.108 c0,13.417,10.666,24.436,24.086,24.436h575.648L583.96,448.375c-9.299,9.63-9.299,25.12,0,34.401 c9.626,9.632,25.128,9.632,34.405,0l215.742-215.742C843.733,257.739,843.733,242.263,834.107,232.981z"/> </g> </g> <g id="Forma_1_copy_1_"> </g> </svg></button>',
        prevArrow:'<button type="button" class="prev-slide"><svg version="1.1" baseProfile="basic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1000px" height="500px" viewBox="0 0 1000 500" xml:space="preserve"> <g id="Forma_1_1_"> </g> <g id="Forma_1_copy_1_"> <g id="Forma_1_copy"> <path fill-rule="evenodd" clip-rule="evenodd" d="M811.881,225.728H245.96L417.457,51.275c9.143-9.269,9.143-24.751,0-34.055 c-9.463-9.627-24.679-9.627-33.821,0l-212.1,215.762c-9.462,9.282-9.462,24.765,0,34.054l212.1,215.742 c9.12,9.627,24.358,9.627,33.821,0c9.143-9.276,9.143-24.772,0-34.4L245.96,274.265h565.921c13.192,0,23.68-11.014,23.68-24.434 C835.561,236.411,825.073,225.749,811.881,225.728z"/> </g> </g> </svg></button>',
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: 3 } },
          { breakpoint: 600,  settings: { slidesToShow: 2 } },
          { breakpoint: 480,  settings: { slidesToShow: 1, slidesToScroll: 1, dots: false, arrows: true } }
        ]
      });
    });
  }
  
  function jsCollection(){
    $('.js_collection').slick({
      dots: true,
      arrows:false,
      infinite: false,
      speed: 300,
      autoplay:false,
      slidesToShow: 3,
      slidesToScroll: 2,
      nextArrow:'<button type="button" class="next-slide"><svg version="1.1" baseProfile="basic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1000px" height="500px" viewBox="0 0 1000 500" xml:space="preserve"> <g id="Forma_1_1_"> <g id="Forma_1"> <path fill-rule="evenodd" clip-rule="evenodd" d="M834.107,232.981L618.365,17.218c-9.3-9.624-24.779-9.624-34.405,0 c-9.299,9.303-9.299,24.778,0,34.059l174.447,174.441H182.759c-13.42,0.021-24.086,10.686-24.086,24.108 c0,13.417,10.666,24.436,24.086,24.436h575.648L583.96,448.375c-9.299,9.63-9.299,25.12,0,34.401 c9.626,9.632,25.128,9.632,34.405,0l215.742-215.742C843.733,257.739,843.733,242.263,834.107,232.981z"/> </g> </g> <g id="Forma_1_copy_1_"> </g> </svg></button>',
      prevArrow:'<button type="button" class="prev-slide"><svg version="1.1" baseProfile="basic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1000px" height="500px" viewBox="0 0 1000 500" xml:space="preserve"> <g id="Forma_1_1_"> </g> <g id="Forma_1_copy_1_"> <g id="Forma_1_copy"> <path fill-rule="evenodd" clip-rule="evenodd" d="M811.881,225.728H245.96L417.457,51.275c9.143-9.269,9.143-24.751,0-34.055 c-9.463-9.627-24.679-9.627-33.821,0l-212.1,215.762c-9.462,9.282-9.462,24.765,0,34.054l212.1,215.742 c9.12,9.627,24.358,9.627,33.821,0c9.143-9.276,9.143-24.772,0-34.4L245.96,274.265h565.921c13.192,0,23.68-11.014,23.68-24.434 C835.561,236.411,825.073,225.749,811.881,225.728z"/> </g> </g> </svg></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            dots: false, 
            arrows: true
          }
        }
      ]
    });

  }

  function slideProductDetail() {
    $('.js_prod_main').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dot: false,
      fade: false,
      infinite: false,
      asNavFor: '.js_prod_sub'
    });
    $('.js_prod_sub').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.js_prod_main',
      dots: false,
      arrows: false,
      infinite: false,
      vertical: true,
      verticalSwiping: true,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            vertical: true,
            infinite: false,
          }
        },
        {
          breakpoint: 768,
          settings: {
            vertical: true,
            infinite: false,
          }
        },

        {
          breakpoint: 575,
          settings: {
            vertical: false,
            infinite: false,
          }
        }
      ]
    });

  }

  function slideProductDetail2() {
    $('.js_prod_main2').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dot: false,
      fade: true,
      infinite: false,
      asNavFor: '.js_prod_sub2'
    });
    $('.js_prod_sub2').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.js_prod_main2',
      dots: false,
      arrows: false,
      infinite: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            infinite: false,
          }
        },
        {
          breakpoint: 768,
          settings: {
            infinite: false,
          }
        },

        {
          breakpoint: 575,
          settings: {
            infinite: false,
          }
        }
      ]
    });

  }
  function slideProductDetailBottom() {
    $('.js_prod_main_bot').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dot: false,
      fade: false,
      infinite: false,
    });


  }

  
  function sizeGuide(){
    // Size Guide modal: close button + click-outside + ESC
    var $content = $('.content_size_guide');
    if (!$content.length) return;

    function getOverlay(){
      // Prefer the overlay that's specifically for the size guide if present
      var $ov = $('.size-guide-overlay');
      if ($ov.length) return $ov;
      // Fallback for older markup
      return $('.overlay');
    }

    function openSizeGuide(){
      $content.addClass('active');
      getOverlay().addClass('active');
      // Disable sticky sidebar while the modal is open
      $('.detail-info').addClass('static');
      $('body').addClass('size-guide-open');
    }

    function closeSizeGuide(){
      if (!$content.hasClass('active')) return; // idempotent
      $content.removeClass('active');
      getOverlay().removeClass('active');
      $('body').removeClass('size-guide-open');
      // Restore sticky sidebar after closing
      $('.detail-info').removeClass('static');

      // Nudge layout so sticky/scroll listeners refresh reliably
      setTimeout(function(){
        $(window).trigger('resize');
        $(window).trigger('scroll');
      }, 50);
    }

    // Open
    $(document)
      .off('click.sizeGuideOpen', '.btn_size_guide')
      .on('click.sizeGuideOpen', '.btn_size_guide', function(e){
        e.preventDefault();
        e.stopPropagation();
        openSizeGuide();
      });

    // Close button (X)
    $(document)
      .off('click.sizeGuideCloseBtn', '.close_size_guide, .close_size_guide a')
      .on('click.sizeGuideCloseBtn', '.close_size_guide, .close_size_guide a', function(e){
        e.preventDefault();
        e.stopPropagation();
        closeSizeGuide();
      });

    // Click on the dimmed area (outside the image/layout) closes.
    // IMPORTANT: use click (not mousedown) so we don't "click-through" onto the page
    // when the modal disappears; this is what was breaking sticky intermittently.
    $(document)
      .off('click.sizeGuideBackdrop', '.content_size_guide')
      .on('click.sizeGuideBackdrop', '.content_size_guide', function(e){
        if (!$content.hasClass('active')) return;
        // Only close when user clicks the backdrop itself (not any child like the image)
        if (e.target !== this) return;
        e.preventDefault();
        e.stopPropagation();
        closeSizeGuide();
      });

    // ESC closes
    $(document)
      .off('keydown.sizeGuideEsc')
      .on('keydown.sizeGuideEsc', function(e){
        if ((e.key === 'Escape' || e.keyCode === 27) && $content.hasClass('active')){
          closeSizeGuide();
        }
      });
  }

  // Init (guarded)
  $(function(){
    try { if ($.fn.slick && $('.js_prod_detail_gallery').length) jsProdDetails_gallery(); } catch(e) {}
    try { if ($.fn.slick && ($('.js_prod_detail').length || $('.js_sticy_imgmb').length)) jsProdDetails(); } catch(e) {}
    try { if ($.fn.slick && ($('.js_prod_detail').length || $('.prod_detail').length)) slideProductDetail(); } catch(e) {}
    try { if ($.fn.slick && ($('.prod_detail').length || $('.prod_detail_bottom').length)) slideProductDetailBottom(); } catch(e) {}
    try { sizeGuide(); } catch(e) {}
    try { if ($.fn.slick && ($('.js_prod_detail').length || $('.prod_detail').length)) slideProductDetail2(); } catch(e) {}
    try { if ($.fn.slick && $('.js_product_related').length) jsProdRelate(); } catch(e) {}
  });

})(window.jQuery);

      ///////ZOOM IMAGE

      jQuery(document).ready(function( $ ) {


        (function ($) {
          var defaults = {
            url: false,
            callback: false,
            target: false,
            duration: 120,
            on: 'mouseover', // other options: grab, click, toggle
            touch: true, // enables a touch fallback
            onZoomIn: false,
            onZoomOut: false,
            magnify: 0.9
          };

          // Core Zoom Logic, independent of event listeners.
          $.zoom = function(target, source, img, magnify) {
            var targetHeight,
                targetWidth,
                sourceHeight,
                sourceWidth,
                xRatio,
                yRatio,
                offset,
                $target = $(target),
                position = $target.css('position'),
                $source = $(source);

            // The parent element needs positioning so that the zoomed element can be correctly positioned within.
            target.style.position = /(absolute|fixed)/.test(position) ? position : 'relative';
            target.style.overflow = 'hidden';
            img.style.width = img.style.height = '';

            $(img)
            .addClass('zoomImg engoj_img_main')
            .css({
              position: 'absolute',
              top: 0,
              left: 0,
              opacity: 0,
              width: img.width * magnify,
              height: img.height * magnify,
              border: 'none',
              maxWidth: 'none',
              maxHeight: 'none'
            })
            .appendTo(target);

            return {
              init: function() {
                targetWidth = $target.outerWidth();
                targetHeight = $target.outerHeight();

                if (source === target) {
                  sourceWidth = targetWidth;
                  sourceHeight = targetHeight;
                } else {
                  sourceWidth = $source.outerWidth();
                  sourceHeight = $source.outerHeight();
                }

                xRatio = (img.width - targetWidth) / sourceWidth;
                yRatio = (img.height - targetHeight) / sourceHeight;

                offset = $source.offset();
              },
              move: function (e) {
                var left = (e.pageX - offset.left),
                    top = (e.pageY - offset.top);

                top = Math.max(Math.min(top, sourceHeight), 0);
                left = Math.max(Math.min(left, sourceWidth), 0);

                img.style.left = (left * -xRatio) + 'px';
                img.style.top = (top * -yRatio) + 'px';
              }
            };
          };

          $.fn.zoom = function (options) {
            return this.each(function () {
              var
              settings = $.extend({}, defaults, options || {}),
                  //target will display the zoomed image
                  target = settings.target && $(settings.target)[0] || this,
                  //source will provide zoom location info (thumbnail)
                  source = this,
                  $source = $(source),
                  img = document.createElement('img'),
                  $img = $(img),
                  mousemove = 'mousemove.zoom',
                  clicked = false,
                  touched = false;

              // If a url wasn't specified, look for an image element.
              if (!settings.url) {
                var srcElement = source.querySelector('img');
                if (srcElement) {
                  settings.url = srcElement.getAttribute('data-src') || srcElement.currentSrc || srcElement.src;
                }
                if (!settings.url) {
                  return;
                }
              }

              $source.one('zoom.destroy', function(position, overflow){
                $source.off(".zoom");
                target.style.position = position;
                target.style.overflow = overflow;
                img.onload = null;
                $img.remove();
              }.bind(this, target.style.position, target.style.overflow));

              img.onload = function () {
                var zoom = $.zoom(target, source, img, settings.magnify);

                function start(e) {
                  zoom.init();
                  zoom.move(e);

                  // Skip the fade-in for IE8 and lower since it chokes on fading-in
                  // and changing position based on mousemovement at the same time.
                  $img.stop()
                  .fadeTo($.support.opacity ? settings.duration : 0, 1, $.isFunction(settings.onZoomIn) ? settings.onZoomIn.call(img) : false);
                }

                function stop() {
                  $img.stop()
                  .fadeTo(settings.duration, 0, $.isFunction(settings.onZoomOut) ? settings.onZoomOut.call(img) : false);
                }

                // Mouse events
                if (settings.on === 'grab') {
                  $source
                  .on('mousedown.zoom',
                      function (e) {
                    if (e.which === 1) {
                      $(document).one('mouseup.zoom',
                                      function () {
                        stop();

                        $(document).off(mousemove, zoom.move);
                      }
                                     );

                      start(e);

                      $(document).on(mousemove, zoom.move);

                      e.preventDefault();
                    }
                  }
                     );
                } else if (settings.on === 'click') {
                  $source.on('click.zoom',
                             function (e) {
                    if (clicked) {
                      // bubble the event up to the document to trigger the unbind.
                      return;
                    } else {
                      clicked = true;
                      start(e);
                      $(document).on(mousemove, zoom.move);
                      $(document).one('click.zoom',
                                      function () {
                        stop();
                        clicked = false;
                        $(document).off(mousemove, zoom.move);
                      }
                                     );
                      return false;
                    }
                  }
                            );
                } else if (settings.on === 'toggle') {
                  $source.on('click.zoom',
                             function (e) {
                    if (clicked) {
                      stop();
                    } else {
                      start(e);
                    }
                    clicked = !clicked;
                  }
                            );
                } else if (settings.on === 'mouseover') {
                  zoom.init(); // Preemptively call init because IE7 will fire the mousemove handler before the hover handler.

                  $source
                  .on('mouseenter.zoom', start)
                  .on('mouseleave.zoom', stop)
                  .on(mousemove, zoom.move);
                }

                // Touch fallback
                if (settings.touch) {
                  $source
                  .on('touchstart.zoom', function (e) {
                e.preventDefault();
                if (touched) {
                  touched = false;
                  stop();
                } else {
                  touched = true;
                  start( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
                }
              })
              .on('touchmove.zoom', function (e) {
                e.preventDefault();
                zoom.move( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
              })
              .on('touchend.zoom', function (e) {
                e.preventDefault();
                if (touched) {
                  touched = false;
                  stop();
                }
              });
            }

            if ($.isFunction(settings.callback)) {
              settings.callback.call(img);
            }
          };

          img.setAttribute('role', 'presentation');
          img.alt = '';
          img.src = settings.url;
        });
      };

          $.fn.zoom.defaults = defaults;
        }(window.jQuery));
        $('.js-zoom-img').zoom();	


      });

